import React from 'react';
import { Box, Typography } from '@mui/material';

import { IPositionWithCandidates } from '@types';
import { useIsPhone } from '@hooks';
import { awaitsReader } from '@utils';
import { ICandidatesControls } from '../controls';
import { CandidateFiltersDialog } from './CandidateFiltersDialog';

interface ICandidatesHeaderProps {
  positions: IPositionWithCandidates[];
  controls?: ICandidatesControls;
}

export const CandidatesHeader: React.FC<ICandidatesHeaderProps> = ({
  positions,
  controls,
}) => {
  const isPhone = useIsPhone();

  const candidates = positions.flatMap((position) => position.candidates ?? []);
  const waitingCount = candidates.filter((candidate) =>
    awaitsReader(candidate),
  ).length;

  return (
    <Box
      px={2}
      pt={3}
      display="flex"
      alignItems={isPhone ? 'center' : 'baseline'}
      gap={1.5}
    >
      <Typography variant="h2" typography={{ xs: 'h3', tablet: 'h2' }}>
        Candidates for your positions
      </Typography>
      {controls && <CandidateFiltersDialog {...controls} />}
      {!isPhone && candidates.length > 0 && (
        <Typography variant="body2" color="text.secondary">
          {candidates.length} shown
          {waitingCount > 0 && ` · ${waitingCount} waiting on you`}
        </Typography>
      )}
    </Box>
  );
};
